/*
 * @Author: fwq 
 * @Date: 2020-03-09 10:11:06 
 * @Last Modified by: fwq
 * @Last Modified time: 2020-03-13 19:05:03
 */
<template>
  <div class="personalCenter">
    <div class="personalCenter-top">
      <div class="personalCenter-topLeft" v-touch:tap="goToSetting">
        <i class="iconfont iconguanlishebei"></i>
      </div>
      <!-- <div class="personalCenter-topRight" v-touch:tap="telephone()">
        <i class="iconfont">&#xe61b;</i>
      </div>-->

      <!-- <div class="bg-box"></div> -->

      <div class="f-p-lr-7">
        <div class="personalCenterBox-top">
          <div class="personalCenterBox-topImg">
            <van-image
              class="user-image"
              width="100%"
              height="100%"
              :src="img"
              fit="scale-down"
            />
          </div>
          <div class="personalCenterBox-topName">{{ name }}</div>
          <div class="personalCenterBox-topPhone">{{ phone }}</div>
          <div class="personalCenterBox-topTitle">
            欢迎您
            <!-- {{ isVolunteer == 1 ? "志愿者" : "普通用户" }} -->
          </div>
          <div class="personalCenterBox-topMessage">
            <div class="topMessage-box" v-touch:tap="$pageIntegral(0)">
              <div class="topMessage-boxImg">
                <van-image class="boxImg1" :src="imgUser" />
              </div>
              <div class="topMessage-boxText">
                用户积分
                <span>{{ sumScore.userScore || 0 }}</span>
              </div>
            </div>
            <div class="topMessage-box" v-touch:tap="$pageIntegral(1)">
              <!-- v-if="getUserInfo.isVolunteer == 1" -->
              <div class="topMessage-boxImg">
                <van-image class="boxImg1" :src="imgVolunteers" />
              </div>
              <div class="topMessage-boxText">
                志愿者积分
                <span>{{ integral || 0 }}</span>
              </div>
            </div>
            <div class="topMessage-line"></div>
          </div>

          <ul class="new-menu-box">
            <li
              class="menu-item-box"
              v-for="(item, index) in List"
              :key="item.text + index"
              v-touch:tap="$page(item.to)"
            >
              <div class="inner-box">
                <van-image class="menu-image" fit="contain" :src="item.img" />
                <div class="text-box">{{ item.text }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 第一版设计的菜单界面 -->
    <div class="personalCenterBox" hidden>
      <!-- <div class="f-p-lr-7">
        <div class="personalCenterBox-top">
          <div class="personalCenterBox-topImg">
            <van-image width="100%" height="100%" :src="img" />
          </div>
          <div class="personalCenterBox-topName">{{name}}</div>
          <div class="personalCenterBox-topPhone">{{phone}}</div>
          <div class="personalCenterBox-topTitle">欢迎您 {{isVolunteer==1?'志愿者':'普通用户'}}</div>
          <div class="personalCenterBox-topMessage">
            <div class="topMessage-box" v-touch:tap="$pageIntegral(0)">
              <div class="topMessage-boxImg">
                <van-image class="boxImg1" :src="imgUser" />
              </div>
              <div class="topMessage-boxText">
                用户积分
                <span>{{sumScore.userScore ||0}}</span>
              </div>
            </div>
            <div
              class="topMessage-box"
              v-touch:tap="$pageIntegral(1)"
              v-if="sumScore.volunteerScore"
            >
              <div class="topMessage-boxImg">
                <van-image class="boxImg2" :src="imgVolunteers" />
              </div>
              <div class="topMessage-boxText">
                志愿者积分
                <span>{{sumScore.volunteerScore}}</span>
              </div>
            </div>
            <div class="topMessage-line"></div>
          </div>
        </div>
      </div> -->

      <div class="personalCenterBox-middle">
        <template v-for="item in List">
          <div
            class="middleBox"
            v-touch:tap="$page(item.to)"
            :key="item.text"
            v-if="item.show === undefined || item.show"
          >
            <div class="g-middle-box">
              <van-image class="middleBox-img" v-bind:src="item.img" />
              <div class="middleBox-text g-b-500">{{ item.text }}</div>
            </div>
            <div class="middleBox-icon">
              <i class="iconfont">&#xe6ab;</i>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div hidden style="width: 0; height: 0">{{ getUserInfo }}</div>
  </div>
</template>
<script>
import http from "@js/http-zyz.js";
import { getSumScoreByOpenid } from "@js/volunteerUrl";
import { getUserInfoByOpenId, getVolunteerUserInfo } from "@url";
import axios from "axios";
export default {
  name: "personal-center",
  data() {
    return {
      img: require("@image/personalCenter/chanegImage/111.png"),
      imgUser: require("../../lib/image/personalCenter/chanegImage/12312.png"),
      imgVolunteers: require("../../lib/image/personalCenter/chanegImage/22.png"),
      testImage: require("@image/personalCenter/chanegImage/10.jpg"),
      name: " ",
      phone: " ",
      sumScore: {},
      integral: "",
      // UserIntegral: "1000",
      // volunteersIntegral: "189",
      List: [
        {
          // img: require("../../lib/image/personalCenter/menpiao.png"),
          img: require("../../lib/image/personalCenter/chanegImage/11.png"),
          text: "门票预约",
          to: {
            name: "OrderList",
            query: {
              type: "tickets",
            },
          },
        },
        {
          // img: require("../../lib/image/personalCenter/1.png"),
          img: require("../../lib/image/personalCenter/chanegImage/33.png"),
          text: "文创商品",
          to: {
            name: "culproduct",
            // query: {
            //   type: "",
            // },
          },
        },
        {
          // img: require("../../lib/image/personalCenter/2.png"),
          img: require("../../lib/image/personalCenter/chanegImage/44.png"),
          text: "活动预约",
          to: {
            name: "OrderList",
            query: {
              type: "signup",
            },
          },
        },
        {
          // img: require("../../lib/image/personalCenter/zyz.png"),
          img: require("../../lib/image/personalCenter/chanegImage/55.png"),
          text: "志愿者活动",
          to: {
            name: "volunteerActivity",
            query: {},
          },
          show: false,
        },
        {
          // img: require("../../lib/image/personalCenter/sq.png"),
          img: require("../../lib/image/personalCenter/chanegImage/66.png"),
          text: "志愿者排班",
          to: { name: "VolunteerSche" },
          show: true,
        },
        // {
        //   img: require("../../lib/image/personalCenter/jiangjieyuan.png"),
        //   text: "预约讲解",
        //   to: { name: "myExplainList" }
        // },
        {
          // img: require("../../lib/image/personalCenter/fuwutongzhi.png"),
          img: require("../../lib/image/personalCenter/chanegImage/88.png"),
          text: "服务指南",
          to: { name: "serviceGuide" },
        },
        {
          // img: require("../../lib/image/personalCenter/gy.png"),
          img: require("../../lib/image/personalCenter/chanegImage/99.png"),
          text: "关于我们",
          to: { name: "aboutus" },
        },
      ],
    };
  },
  created() {
    // this.getSumScoreByOpenidƒ();
    this.getVoIntegral();
    getUserInfoByOpenId(this.openId);
  },
  methods: {
    //页面跳转
    $page(to) {
      return () => {
        // 点击的是志愿者模块 且 进度为申请中的时候
        if (to.name === "fillApplyVolunteerInfo" && this.isVolunteer == 2) {
          this.$router.push({
            name: "VolunteerProgress",
          });
          return;
          //  已经是志愿者了
        } else if (
          to.name === "fillApplyVolunteerInfo" &&
          this.isVolunteer == 1
        ) {
          this.$router.push({
            name: "settingPage",
            query: { type: "volunteer" },
          });
          return;
        }
        this.$router.push(to);
      };
    },
    //跳转积分明细页面
    $pageIntegral(index) {
      return () => {
        // this.$router
        //   .push({ path: "integral", query: { index, sumScore: this.sumScore } })
        //   .catch((err) => {
        //     err;
        //   });
      };
    },
    // 志愿者积分
    getVoIntegral() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        return this.$toast("请先绑定手机号！");
      }
      axios
        .get(getVolunteerUserInfo, {
          params: { phone: this.userPhone },
        })
        .then(({ data: { data, code } }) => {
          if (code == 200) {
            this.integral = data.data.integral;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSumScoreByOpenidƒ() {
      http.post(getSumScoreByOpenid, { openId: this.openId }).then((res) => {
        this.sumScore = res.data.data;
      });
    },
    goToSetting() {
      this.$router.push("settingPage");
    },
  },
  computed: {
    // isVolunteer() {
    //   //  isVolunteer 是否是志愿者（0-否，1-是，2审核中）
    //   let isVolunteer = this.$store.state.userInfo.info.isVolunteer;
    //   let flag = isVolunteer == 1;
    //   this.List[3].show = flag;
    //   // this.List[4].show = !flag;

    //   switch (isVolunteer) {
    //     case 1:
    //       this.List[4].text = "我的志愿者信息";
    //       break;
    //     case 2:
    //       this.List[4].text = "志愿者申请进度";
    //       break;
    //     default:
    //       this.List[4].text = "申请成为志愿者";
    //       break;
    //   }
    //   return isVolunteer;
    // },
    // 用户手机号
    userPhone() {
      return this.$store.state.userInfo.info.phone;
    },
    openId() {
      return this.$store.state.userInfo.openId;
    },
    getUserInfo() {
      var info = this.$store.state.userInfo.info || false;
      if (info) {
        this.name = info.userName;
        this.phone = info.phone;
      }
      return info;
    },
  },
};
</script>

<style lang="less" scoped>
.personalCenter {
  background-color: #eff0fa !important;
  background: url("~@image/personalCenter/chanegImage/10.jpg") center center
    no-repeat;
  background-size: 100% 100%;
  .personalCenter-top {
    // height: 240px;
    // background: linear-gradient(
    //   114deg,
    //   rgba(42, 180, 231, 1) 0%,
    //   rgba(118, 124, 237, 1) 100%
    // );
    // border-bottom-left-radius: 30px;
    // border-bottom-right-radius: 30px;
    // height: auto;
    overflow: hidden;
    position: relative;
    .bg-box {
      // height: 240px;
      // margin-bottom: 70px;
      // background: linear-gradient(
      //   114deg,
      //   rgba(42, 180, 231, 1) 0%,
      //   rgba(118, 124, 237, 1) 100%
      // );
      // border-bottom-left-radius: 30px;
      // border-bottom-right-radius: 30px;
    }
    .personalCenter-topLeft {
      // position: absolute;
      // top: 28px;
      // left: 16px;
      padding-top: 7px;
      padding-left: 7px;
      .iconfont {
        color: #fff;
        font-size: 24px;
      }
    }
    .personalCenter-topRight {
      position: absolute;
      top: 28px;
      right: 16px;
      .iconfont {
        color: #fff;
        font-size: 24px;
      }
    }

    .f-p-lr-7 {
      padding: 0 7px;
      position: relative;
      margin-top: 60px;
      margin-bottom: 24px;
      // position: absolute;
      // left: 7px;
      // right: 7px;
      // bottom: -50px;
      // bottom: 0px;
      // z-index: 20;
      // padding: 0 7px;
      .personalCenterBox-top {
        // background: rgba(255, 255, 255, 1);
        // box-shadow: 0px 6px 13px 0px rgba(229, 229, 229, 1);
        // border-radius: 9px;
        min-height: 180px;
        padding: 15px;
        position: relative;

        background: rgba(255, 255, 255, 0.85);
        box-shadow: 0px 3px 7px 0px rgba(206, 215, 205, 0.35);
        border-radius: 20px;

        .personalCenterBox-topImg {
          position: absolute;
          left: 50%;
          top: -42px;
          transform: translate(-50%, 0);
          height: 85px;
          width: 85px;
          padding: 5px;
          .user-image {
            border-radius: 100%;
            background: rgba(254, 253, 245, 1);
            box-shadow: 0px 3px 10px 0px rgba(232, 190, 129, 0.52);
          }
        }
        .personalCenterBox-topName {
          text-align: center;
          color: #343434;
          font-size: 20px;
          padding-top: 53px;
          line-height: 28px;
        }
        .personalCenterBox-topPhone {
          text-align: center;
          color: #838383;
          font-size: 14px;
          line-height: 20px;
        }
        .personalCenterBox-topTitle {
          text-align: center;
          color: #bebebe;
          font-size: 12px;
          line-height: 18px;
        }
        .personalCenterBox-topMessage {
          margin-top: 5px;
          position: relative;
          .topMessage-box {
            width: 50%;
            display: inline-block;
            position: relative;
            padding-top: 26px;
            .topMessage-boxImg {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, 0);
              .boxImg1 {
                width: 25px;
                height: 25px;
              }
              .boxImg2 {
                width: 24px;
                height: 27px;
              }
            }
            .topMessage-boxText {
              color: #47535f;
              font-size: 14px;
              text-align: center;
              font-weight: 500;
              padding-top: 4px;
              span {
                color: #fb851c;
                font-size: 14px;
                padding-left: 5px;
                font-weight: 500;
              }
            }
          }
          .topMessage-line {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // border-left: 0.5px solid #cdcdcd;
            border-left: 0.5px solid rgba(245, 224, 146, 1);
            height: 31px;
          }
        }
      }
    }
  }
  .personalCenterBox {
    position: relative;
    padding: 0 7px 7px;
    // top: -133px;
    .f-p-lr-7 {
      padding: 0 7px;
      .personalCenterBox-top {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 6px 13px 0px rgba(229, 229, 229, 1);
        border-radius: 9px;
        min-height: 180px;
        padding: 15px;
        position: relative;
        .personalCenterBox-topImg {
          position: absolute;
          left: 50%;
          top: -42px;
          transform: translate(-50%, 0);
          height: 85px;
          width: 85px;
          padding: 5px;
        }
        .personalCenterBox-topName {
          text-align: center;
          color: #343434;
          font-size: 20px;
          padding-top: 53px;
          line-height: 28px;
        }
        .personalCenterBox-topPhone {
          text-align: center;
          color: #838383;
          font-size: 14px;
          line-height: 20px;
        }
        .personalCenterBox-topTitle {
          text-align: center;
          color: #bebebe;
          font-size: 12px;
          line-height: 18px;
        }
        .personalCenterBox-topMessage {
          margin-top: 5px;
          position: relative;
          .topMessage-box {
            width: 50%;
            display: inline-block;
            position: relative;
            padding-top: 26px;
            .topMessage-boxImg {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, 0);
              .boxImg1 {
                width: 25px;
                height: 25px;
              }
              .boxImg2 {
                width: 24px;
                height: 27px;
              }
            }
            .topMessage-boxText {
              color: #47535f;
              font-size: 14px;
              text-align: center;
              font-weight: 500;
              padding-top: 4px;
              span {
                color: #fb851c;
                font-size: 14px;
                padding-left: 5px;
                font-weight: 500;
              }
            }
          }
          .topMessage-line {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-left: 0.5px solid #cdcdcd;
            height: 31px;
          }
        }
      }
    }
    .personalCenterBox-middle {
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      margin-top: 17px;
      padding: 0 10px;
      .middleBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 46px;
        zoom: 1;
        overflow: auto;
        border-top: 0.5px solid #d9d9d9;
        .g-middle-box {
          display: flex;
          align-items: center;
        }
        .middleBox-text {
          //   float: left;
          font-size: 12px;
          color: #6e6e6e;
          line-height: 20px;
        }
        .middleBox-icon {
          //   float: right;
          //   line-height: 20px;
          .iconfont {
            color: #d4d4d4;
          }
        }
        .middleBox-img {
          // float: left;
          margin-right: 10px;
          width: 24px;
          transform: translateY(1px);
        }
        // .middleBox-img1{
        //     width:23px;
        //     height:16px;
        // }
        // .middleBox-img2{
        //     width:21px;
        //     height:23px;
        // }
        // .middleBox-img3{
        //     width:17px;
        //     height:23px;
        // }
        // .middleBox-img4{
        //     width:23px;
        //     height:20px;
        // }
        // .middleBox-img5{
        //     width:19px;
        //     height:20px;
        // }
        // .middleBox-img6{
        //     width:21px;
        //     height:17px;
        // }
        // .middleBox-img7{
        //     width:19px;
        //     height:16px;
        // }
      }
      .middleBox:nth-child(1) {
        border: none;
      }
    }
  }

  .new-menu-box {
    margin-top: 24px;
    border-radius: 20px;
    overflow: hidden;
    .menu-item-box {
      display: inline-flex;
      padding: 1px;
      width: 33.33%;
      box-sizing: border-box;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: top;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(110, 110, 110, 1);
      .inner-box {
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        .menu-image {
          height: 24px;
          margin-bottom: 5px;
        }
        .text-box {
          padding: 0 5px;
          text-align: center;
        }
      }
    }
  }
}
</style>